import { authTypes } from './auth.types';

export const setLoginRequest = () => ({
  type: authTypes.LOGIN_REQUEST,
});

export const setLoginSuccess = (data: any) => ({
  type: authTypes.LOGIN_SUCCESS,
  payload: data,
});

export const setLoginFailure = () => ({
  type: authTypes.LOGIN_FAILURE,
});

export const resetLogin = () => ({
  type: authTypes.RESET_LOGIN,
});

export const setLogoutRequest = () => ({
  type: authTypes.LOGOUT_REQUEST,
});

export const setLogoutSuccess = () => ({
  type: authTypes.LOGOUT_SUCCESS,
});

export const setLogoutFailure = () => ({
  type: authTypes.LOGOUT_FAILURE,
});

export const setRefreshTokenRequest = () => ({
  type: authTypes.REFRESH_TOKEN_REQUEST,
});

export const setRefreshTokenSuccess = (data: any) => ({
  type: authTypes.REFRESH_TOKEN_SUCCESS,
  payload: data,
});

export const setRefreshTokenFailure = () => ({
  type: authTypes.REFRESH_TOKEN_FAILURE,
});
